import { render, staticRenderFns } from "./Auftraege_All.vue?vue&type=template&id=32b56ffa&scoped=true"
import script from "./Auftraege_All.vue?vue&type=script&lang=js"
export * from "./Auftraege_All.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b56ffa",
  null
  
)

export default component.exports